import React, { useState, useEffect } from 'react';
import { Dropdown } from 'react-bootstrap'
import Label, { useLabels } from "components/general/Label"
import { useUrlFriendlyToParameters, useNavigateTo } from 'helpers/urlFriendly';
import { useGetNocs } from 'helpers/commonCodes';
import Noc from 'components/presentation/Noc';
import { isParalympic, CompetitionFromStore, splitArrayIntoFourColumns } from 'helpers/utils'
import { ALL_URL } from "helpers/utils";
import Form from 'react-bootstrap/Form';
import { TYPE_DATA, sortDataByField } from "helpers/utils";
import { FilterEventTypes, createEventData, pagesWithNOCFilter, publishFilterEvent } from 'components/common/ocs-custom-events/filterEvents';

export default function SelectorNoc({ page = "", nocsList, useNocList = false, onSelectNoc, selectedNoc }) {
    const [textCombo, setTextCombo] = useState();
    let params = useUrlFriendlyToParameters()
    const [paramsUrl, setParamsUrl] = useState({});
    const [shouldNavigate, setShouldNavigate] = useState(false);
    const [filterText, setFilterText] = useState('');
    const [arrayOfColumns, setArrayOfColumns] = useState([]);
    useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, page)
    const fLabel = useLabels()

    //copy parameters URL to change 
    let paramsURL = { ...params }
    //paramsURL["mirs_noc"] = "";
    let label = 'LabelAllNocs';
    const competition = CompetitionFromStore();
    if (isParalympic(competition) && label === 'LabelAllNocs') {
        label = 'LabelAllNpcs';
    };
    const data = useGetNocs(paramsURL);

    useEffect(() => {
        let filteredNocs = data?.nocs;
        if (useNocList && Array.isArray(nocsList)) {
            filteredNocs = filteredNocs?.filter((n) => nocsList?.includes(n?.code));
        }
        if (filterText) {
            filteredNocs = filteredNocs?.filter((n => {
                return n?.longDescription?.toLowerCase().includes(filterText?.toLowerCase())
            }))
        };
        sortDataByField(filteredNocs, "longDescriptionOrder", true, TYPE_DATA.NUMBER);
        const allNocs = !['schedulebynoc', 'athletesbynoc'].includes(page) && <Dropdown.Item key="Selector-Noc-All" eventKey={ALL_URL.ALL_NOC} >
            <Label data={label} />
        </Dropdown.Item>

        const options = filteredNocs?.filter(n => n.note === 'P')?.map((item) => {
            return (

                <Dropdown.Item key={"Selector-Noc-" + item.code} eventKey={item.code} >
                    <ItemNoc nocnode={item} />
                </Dropdown.Item>
            )
        });

        const allItems = [...(allNocs ? [allNocs] : []), ...(options ? options : []),];
        const splittedArray = splitArrayIntoFourColumns(allItems);
        setArrayOfColumns(splittedArray);

    }, [data?.nocs, page, label, filterText, nocsList, useNocList]);


    useEffect(() => {
        const selectedNOC = ['records', 'medal', 'medallists', 'multimedallists'].includes(page) ? selectedNoc : paramsURL["mirs_noc"];
        let lbl = data?.nocs?.find(item => item.code === selectedNOC)?.description;
        if (!lbl) { lbl = <Label data={'LabelAllNocs'} /> }
        setTextCombo(lbl);
    }, [paramsURL["mirs_noc"], data?.nocs, selectedNoc, page]);



    //Go to schedule 
    const handleOnChange = (key) => {
        paramsURL["mirs_noc"] = key;
        if (page === 'schedulebynoc') {
            paramsURL["mirs_event"] = "";
            paramsURL["mirs_date"] = "";
            paramsURL["mirs_discipline"] = "";
        }
        // publish on filter event
        if (pagesWithNOCFilter.includes(page)) {
            const payload = createEventData(FilterEventTypes.NOC, key);
            publishFilterEvent(payload);
        }

        // use on page filter, "no navigation"
        if (['records', 'medal', 'medallists', 'multimedallists'].includes(page)) {
            onSelectNoc(key);
        } else {
            setParamsUrl(paramsURL);
            setShouldNavigate(true);
        }
    };

    const onTypeNoc = (noc) => {
        setFilterText(noc);
    }


    return (
        <Dropdown onSelect={handleOnChange} id="selectorNoc" className={"selectorContainer dropdownWithGrid"}>
            <Dropdown.Toggle as={CustomToggle} variant="success"  >
                {textCombo}
            </Dropdown.Toggle>

            <Dropdown.Menu as={CustomMenu} onTypeNoc={onTypeNoc} filteredText={filterText} fLabel={fLabel} >
                {arrayOfColumns}
            </Dropdown.Menu>
        </Dropdown >
    )
};


const ItemNoc = (props) => {
    const { mirs_competition } = useUrlFriendlyToParameters()
    let competition = mirs_competition;
    const [showImage, setShowImage] = useState(true);
    const hideImg = (event) => {
        // this.setState({ showImg: false });
        setShowImage(true);
    };
    props.nocnode.showLongDesc = true;
    return (
        <div className="itemNoc justify-content-left">
            <Noc {...props.nocnode} />
        </div>
    )
};





// The forwardRef is important!!
// Dropdown needs access to the DOM node in order to position the Menu
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (

    <Dropdown.Toggle variant="success" id="selectorNocToggle"
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}

    >
        {children}
    </Dropdown.Toggle>

));

// forwardRef again here!
// Dropdown needs access to the DOM of the Menu to measure it
const CustomMenu = React.forwardRef(
    ({ children, style, className, 'aria-labelledby': labeledBy, onTypeNoc, filteredText, fLabel }, ref) => {
        // const [value, setValue] = useState('');
        const handleInputChange = (e) => {
            const newValue = e.target.value;
            // Invoke the onChange callback passed from the parent
            if (onTypeNoc) {
                onTypeNoc(newValue);
            }
        };
        const placeholder = fLabel({ data: 'LabelTypeToFilter' });
        return (
            <div
                ref={ref}
                style={style}
                className={className}
                aria-labelledby={labeledBy}
            >
                <Form.Control
                    autoFocus
                    className="mx-3 my-2 w-auto"
                    placeholder={placeholder}
                    onChange={handleInputChange}
                    value={filteredText}
                />
                <ul className="list-unstyled">
                    {React.Children.toArray(children)}
                </ul>
            </div>
        );
    },
);
